import { render, staticRenderFns } from "./PromotionsPagination.vue?vue&type=template&id=330a7f5e&"
import script from "./PromotionsPagination.vue?vue&type=script&lang=js&"
export * from "./PromotionsPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('330a7f5e')) {
      api.createRecord('330a7f5e', component.options)
    } else {
      api.reload('330a7f5e', component.options)
    }
    module.hot.accept("./PromotionsPagination.vue?vue&type=template&id=330a7f5e&", function () {
      api.rerender('330a7f5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/promotions/components/PromotionsPagination.vue"
export default component.exports